import { Component, Prop, h } from '@stencil/core';
import { FinancialLease } from '../../types';

@Component({
  tag: 'kia-finanslease',
})
export class Priskort {
  @Prop() data: FinancialLease;

  render() {
    return (
      <div class="kia_price_card--module">
        <h5>Kia Finansiell Leasing</h5>
        {/* <p>Från {formatNumber(this.data.rent_4500)} kr/mån</p> */}
      </div>
    );
  }
}
